<template>
  <VuePerfectScrollbar class="views-list">
    <div v-for="(views, day, index) in groupedViews"
        class="day"
        :key="index">
      <div class="day-header">
        <div class="day-name">
          {{ day | relativeTimeInDays(2) | capitalize }}
        </div>
      </div>

      <ul class="day-view-list">
        <youtube-list-item v-for="(view, index) in views"
                           :key="index"
                           :item="view"/>
      </ul>
    </div>
    <base-scroll-to-top />
  </VuePerfectScrollbar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  import YoutubeListItem from '@/components/Child/ChildTabs/TabYouTube/YouTubeListItem'

  export default {
    props: {
      views: {
        type: Array,
        required: true
      }
    },

    components: {
      YoutubeListItem,
      VuePerfectScrollbar
    },

    computed: {
      groupedViews() {
        return _.groupBy(
          this.views,
          // transform the date string to milliseconds of the beginning of the day
          // "2021-02-01T00:01:00.000Z" => 1611964800000 (milliseconds)
          view => +new Date(view.time).setHours(0,0,0,0)
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .views-list {
    height: 100%;
    padding-bottom: 100px;
    position: relative;

    .day-header {
      display: flex;
      justify-content: center;
      margin: 12px 0 15px 0;
    }

    .day-name {
      opacity: .3;
      color: #fff;
      background: #6a6a6a;
      font-size: 16px;
      border-radius: 14px;
      padding: 5px 16px 5px 16px;
    }

    .day-view-list {
      margin: 0;
      padding: 0 20px;
    }
  }
</style>
